/**
 * created by lei lei on 2020/6/15
 * 图标表多种自定义
 *  titleKeyList={[{key: 'name',//键值
                        titleName: '名称',//表头名
                        width: 500,//宽度支持百分比，数值自定义
                        align: 'center'，
                        ellipsis：true，//属性参考antd，直接添加会自引用
                        },
                        {key: 'age',
                            titleName: '年龄',
                            width: 300,
                            align: 'left',//对齐方式
                            render: (text, record, index)=>{
                                return <a  style={{color:'red'}}>{record.age}</a>  //自定义render 方法
                            }
                        },
                        {key: 'address',
                            titleName: '地址',
                            width: '20%'},]}
 对数据源和列优化自定义，不用写繁琐的代码
 其余的属性全部用antd table的属性，会全部拷贝进去。自动生成key 值，不用在传入key
 也支持columns 自定义，参照官方文档，会覆盖自定义 titleKeyList 所生成的列的所有属性
 titleKeyList除了key 和titleName 属性外，其余的扩展的全部增加到columns
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Table,} from 'antd';
import weChat from './img/wechat.png'
import microBlog from './img/microBlog.png'
import tiktok from './img/tiktok.png'
import notFiled from './img/notFiled.png'

let index = 0;
const customIcon = [{    //新增新图标放到img ，然后引入，自己加入枚举值。
    type: 'notFiled',
    icon: notFiled
}, {
    type: 'weChat',
    icon: weChat
}, {
    type: 'microBlog',
    icon: microBlog
}, {
    type: 'tiktok',
    icon: tiktok
},]
export default class CustomTable extends Component {
    static defaultProps = {};
    static propTypes = {
        dataSource: PropTypes.array.isRequired,//数据源必传项
        titleKeyList: PropTypes.array.isRequired,//列名称必传项
    }

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render() {
        index=0;
        this.addKey(this.props.dataSource);
        let columns = [];
        this.props.titleKeyList.map((item, index) => {
            let Item = {
                title: item.titleName,
                dataIndex: item.key,
                key: item.key,
                ...item
            }
            columns.push(
                Item
            )
        })
        return (
            <div className={'CustomTable'}
                 style={this.props.defineStyle ? {...this.props.defineStyle} : {background: 'white',padding: 20,borderRadius:"0 0 5px 5px"}}>
                <div>
                    <Table dataSource={this.props.dataSource} columns={columns}
                           {...this.props} //复制属性，复制antd 的属性，前面的属性参考antd table的用法即可。实行简单的封装
                    />
                </div>
                <style>{`
                    .CustomTable .ant-table-placeholder{border-bottom: 0;}
                    .CustomTable .ant-table-row:nth-child(2n) {
                        background-color: rgba(245, 248, 252, 1);
                    }
                `}</style>
            </div>
        )
    }

    addKey(data) {
        if (data && data.length > 0) {
            data.forEach((item) => {
                index++;
                item.key = index;
                if (this.props.childrenColumnName) {
                    //这个值是取得组件传入的子节点的键值。
                    let childKey = this.props.childrenColumnName;/*?this.props.childrenColumnName:'children'*/
                    if (item[childKey] && item[childKey].length < 1) {
                        item[childKey] = null;
                    }
                    this.addKey(item[childKey]);
                }
            })
        }
    }

}

export class TitleIcon extends Component {
    static defaultProps = {
        title: '',
    }
    static propTypes = {
        title: PropTypes.string,//标题非必传项
        iconType: PropTypes.string.isRequired,// 图标类型必传项


    }

    render() {
        let icon;
        customIcon.forEach((item, i) => {
            if (this.props.iconType === item.type) {
                icon = item.icon;
            }
        })
        return (
            <div><span>{this.props.title} <span><img style={{width: 15,objectFit:'cover'}} src={icon} alt=""/></span>  </span>
            </div>
        )
    }
}